// @flow
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import CheckBox from './CheckBox';
import Chevron from './Chevron';
import { Icon, Text, TouchableNative } from '../../design/components';
import { designConstants } from '../../design/styles';
import * as Animatable from 'react-native-animatable';
import useThemeContext from '../../design/styles/useThemeContext';

type Props = {
  header: string,
  secondary: string,
  secondaryTextBlue: boolean,
  selected: boolean,
  severityMode: string,
};

export default function SectionHeader(props: Props) {
  const [selectedSlide, setSelectedSlide] = useState(props.selected ? 6 : 0);
  const { colors } = useThemeContext();
  useEffect(() => {
    setSelectedSlide(props.selected ? 6 : 0);
  }, [props.selected]);

  const {
    selected,
    checked,
    onCheckPressed,
    style,
    header,
    secondary,
    secondaryTextBlue,
    expanded,
    canExpand,
    onExpandPressed,
    severityMode,
    renderCounter,
  } = props;
  const isTablet = designConstants.useIsTablet();
  const isReportSection = !!onCheckPressed;

  return (
    <Animatable.View
      transition="marginRight"
      duration={500}
      style={[
        styles.container,
        { backgroundColor: colors.defaultBackground, ...style },
      ]}
    >
      {onCheckPressed && (
        <CheckBox
          label=""
          style={{
            width: 48,
            alignSelf: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onPress={onCheckPressed}
          checked={checked === 1}
        />
      )}
      {isTablet && (
        <Animatable.View
          duration={500}
          transition="width"
          style={{
            position: 'absolute',
            top: -2,
            bottom: -1,
            left: -2,
            width: selectedSlide,
            borderBottomLeftRadius: 4,
            borderTopLeftRadius: 4,
            backgroundColor: colors.buttonblue,
          }}
        />
      )}
      {isTablet && (
        <Animatable.View
          duration={500}
          transition="width"
          style={{ width: selectedSlide }}
        />
      )}
      <Animatable.View
        style={{ flex: 5, justifyContent: 'center', flexDirection: 'column' }}
      >
        <Text numberOfLines={isReportSection ? 1 : undefined}>{header}</Text>
        {!!secondary && (
          <Text gray blue={secondaryTextBlue} small>
            {secondary}
          </Text>
        )}
      </Animatable.View>
      {!!renderCounter && renderCounter}
      {isTablet &&
        (selected ? (
          <Icon
            name={'chevron-right'}
            type={'Entypo'}
            style={{ color: colors.textSecondary, width: 26 }}
          />
        ) : !severityMode ? (
          <View style={{ width: 26 }} />
        ) : null)}
      {canExpand && (
        <TouchableNative onPress={onExpandPressed}>
          <View
            style={{
              width: 48,
              height: 48,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Chevron expanded={expanded} />
          </View>
        </TouchableNative>
      )}
    </Animatable.View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingLeft: designConstants.paddings.edgePadding,
    flexDirection: 'row',
    paddingVertical: 14,
    minHeight: 46,
    alignItems: 'center',
  },
  collapse: {
    flexWrap: 'wrap',
    flex: 0,
  },
});
